export default __webpack_public_path__ + "static/media/ic-social-ig.e89199a8.svg";